import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac7f205e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Company", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Building a single version of the truth.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Founded in Dec 2011, the company has been working intensively towards cloud-based solutions for risk and portfolio management. Our products have been designed to allow users to start analysing risk on their derivatives portfolios in a matter of minutes. With industrial standard models and sanitised market data as standard, customers can focus on the business of business, while we concentrate on the business of risk.", -1))
const _hoisted_4 = { class: "grid align" }
const _hoisted_5 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!
  const _component_headshot = _resolveComponent("headshot")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head",
      bg: true
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_panel, null, {
      default: _withCtx(() => [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company, (team, teamName) => {
          return (_openBlock(), _createElementBlock("div", { key: team }, [
            _createElementVNode("h3", null, _toDisplayString(teamName), 1),
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team, (employee) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: employee.name
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: _ctx.routeName(employee.name)}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_headshot, {
                        name: employee.name,
                        job: employee.role
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _ctx.thumb(employee.name),
                            alt: _ctx.altText(employee.name)
                          }, null, 8, _hoisted_5)
                        ]),
                        _: 2
                      }, 1032, ["name", "job"])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}